export const filterIconButtonStyles = {
  padding: '2px',
  opacity: 0,
  transition: 'opacity 0.2s ease, color 0.2s ease',

  '&.filter-active': {
    opacity: 1,
    color: 'primary.main',
  },
};

export const popoverSlotProps = {
  paper: {
    sx: {
      borderRadius: '8px',
      boxShadow: ({ shadows }) => shadows[4],
      minWidth: '220px',
    },
  },
};

export const popoverContentStyles = {
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const filterInputStyles = {
  '& .MuiOutlinedInput-root': {
    fontSize: '1.4rem',
  },
};

export const filterModeSelectStyles = {
  fontSize: '1.4rem',
  '& .MuiSelect-select': {
    padding: '8px 12px',
  },
};

export const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const transformOrigin = {
  vertical: 'top',
  horizontal: 'left',
};
